import { goBack, Common } from "../common";
import { Util } from "../util";

import '../../css/shared/header.css';
import { IAddressFormat } from "../interfaces/global.interfaces";

export class Header {
    private _displayPage: Function | null;

    constructor(displayPage: Function | null) {
        this._displayPage = displayPage;
        this._init();
    }

    private _init = (): void => {
        this._renderPage();
        this._setEventListeners();
    }

    private _renderPage = (): void => {
        const tempAddress: IAddressFormat = {
            StreetNo: aOLO.storeInfo.StreetNumber,
            Address1: aOLO.storeInfo.Address1,
            Address2: aOLO.storeInfo.Address2,
            Address3: aOLO.storeInfo.Address3,
            Address4: aOLO.storeInfo.Address4,
            Address5: aOLO.storeInfo.Address5,
            City: aOLO.storeInfo.City,
            State: aOLO.storeInfo.State,
            ZipCode: aOLO.storeInfo.Zip,
            CountryID: aOLO.storeInfo.Country.CountryID || 1,
            AddressTypeID: 0
        };

        const addressObject = Util.formatAddressObject(tempAddress, aOLO);
        Util.setElement("innerText", "div_header_store_address", `${addressObject.address1},`);
        Util.setElement("innerText", "div_header_store_city_state_zip", addressObject.cityState);
    }

    private _setEventListeners = (): void => {
        const darkMode = document.getElementsByName("btn_dark_mode");
        darkMode.forEach(x => {
            x.onclick = () => { Common.toggleDarkMode(aOLO.Temp, aOLO.ProfileUser); };
        });

        Util.setElement("onclick", "btn_header_order_now_desktop", () => {
            if (this._displayPage)
                this._displayPage('locations', true);
        });

        if (Util.isWebView()) {
            if (aOLO.isBrandSignIn && Util.isiOS()) {
                Util.setElementClass("add", "div_header", "store-info-app");
                Util.setElementClass("add", "nav_main_hamburger_toggler", "app");
                Util.setElementClass("add", "nav_main_hamburger_menu", "app");
                Util.setElement("onclick", "div_header_back_button", () => {
                    goBack();
                });
            }

            if (aOLO.storeInfo.BrandID.toLowerCase() !== '8402E2D5-B196-4574-9DDD-30C5615F57A1'.toLowerCase()) // Temp Fix for Punchh MMP App
                Util.setElement("onclick", "img_header_store_logo", () => {
                    if (aOLO.isBrandSignIn && this._displayPage)
                        this._displayPage('landing', true);
                    else {
                        const url = `${location.origin}/brand/?sk=${aOLO.storeInfo.StoreKey}&mobile=true`;
                        window.location.href = url;
                    }
                });
        }
    }
}